import "./searchPanel.scss";

import PropTypes from "prop-types";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import ListView from "../../components/listView/ListView";
import { PropTypeShapes } from "../../types";
import SearchResultItem from "./SearchResultItem";

const SearchResultList = props => {
  const { matchingItems } = props;
  const selectedIndex = matchingItems.findIndex(i => props.selectedItemIds.includes(i.id));
  const onItemClick = newIndex => props.onItemClick(matchingItems.find((item, index) => index === newIndex).id);

  const itemRenderer = (item, isSelected, ref) => (
    <SearchResultItem
      forwardedRef={ref}
      key={item.id}
      {...item.toJS()}
      selected={isSelected}
      onClick={props.onItemClick}
      onDoubleClick={props.onItemDoubleClick}
      itemId={item.id}
      viewId={props.viewId}
      width={props.width}
    />
  );

  return (
    <div className="searchResultList">
      <ListView
        items={props.matchingItems}
        selectedItemIndex={selectedIndex}
        onItemSelect={onItemClick}
        itemRenderer={itemRenderer}
        isEnterToSelect={false}
      />
    </div>
  );
};

SearchResultList.propTypes = {
  viewId: PropTypes.string.isRequired,
  matchingItems: PropTypeShapes.searchResultList,
  selectedItemIds: ImmutablePropTypes.listOf(PropTypes.string),
  onItemClick: PropTypes.func.isRequired,
  onItemDoubleClick: PropTypes.func.isRequired,
  width: PropTypes.number.isRequired
};

export default SearchResultList;
